<template>
    <div class="ticket-confirm">
        <div class="summary">
            <span>合计：</span>
            <span class="red-money">{{money | formatPrice}}</span>
        </div>
<!--        <van-button type="default" class="btn-confirm" @click="onSubmit">去交费</van-button>-->
        <mobile-button class="btn-font btn-test" color="#ab2c31" @click="onSubmit">
            去交费
        </mobile-button>
    </div>
</template>
<script>

    import MobileButton from "components/mobile-button/index";
    export default {
        name: "ticketConfirm",
        components: {MobileButton},
        props: {
            model: Object,
        },
        computed: {
            money() {
                let {money, count} = this.model
                money = Number(money)
                count = Number(count)
                return money * count
            }
        },
        data() {
            return {}
        },
        methods: {
            onCancel() {
                this.$router.back()
            },
            onSubmit() {
                this.$emit('commit')
            },
        },
        created() {

        },
    }
</script>
<style lang="scss" scoped>
    .btn-test {
        padding-left: 18px;
        padding-right: 18px;
    }
</style>
